import { render, staticRenderFns } from "./anomaly.vue?vue&type=template&id=8702cbb2&"
import script from "./anomaly.vue?vue&type=script&lang=js&"
export * from "./anomaly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports